import { render, staticRenderFns } from "./RepresentativesCreateForm.vue?vue&type=template&id=81b823b4"
import script from "./RepresentativesCreateForm.vue?vue&type=script&lang=ts"
export * from "./RepresentativesCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports